import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base } from "../base";
import { Customer } from "../customers/customer";
import { Order } from "../orders/order";
import {
  IAddWorkOrderItem,
  IUpdateWorkOrderItem,
  WorkOrderItem,
} from "./work-order-item";

export const WorkOrder = types
  .compose(
    Base,
    types.model({
      orderNumber: types.maybeNull(types.number),
      date: types.maybeNull(types.string),
      woNumber: types.maybeNull(types.string),
      purchaseOrderId: types.maybeNull(types.string),
      customerId: types.maybeNull(types.string),
      customer: types.maybeNull(Customer),
      purchaseOrder: types.maybeNull(Order),
      note: types.maybeNull(types.string),
      items: types.optional(types.array(WorkOrderItem), []),
    })
  )
  .actions(withSetPropAction);
export interface IWorkOrder extends Instance<typeof WorkOrder> {}
export interface IWorkOrderProperties extends SnapshotIn<typeof WorkOrder> {}
export interface IAddWorkOrder
  extends Pick<
    IWorkOrderProperties,
    "date" | "woNumber" | "note" | "purchaseOrderId" | "customerId"
  > {
  items: IAddWorkOrderItem[];
}

export interface IUpdateWorkOrder
  extends Pick<
    IWorkOrderProperties,
    "id" | "date" | "woNumber" | "purchaseOrderId" | "customerId" | "note"
  > {
  items: IUpdateWorkOrderItem[];
}
